module.exports = __webpack_public_path__ + "static/media/ship.b92ce677.svg";